import { action, observable } from 'mobx';
import FooterService from '../services/FooterService';

class FooterStore {
    @observable footerData = null;

    @action
    loadFooter() {
        return FooterService.getFooterData().then((res) => {
            this.footerData = res;
        });
    }
}

export default new FooterStore();
